// src/pages/Upload/UploadTabs.jsx
import React from "react";
import { NavLink } from "react-router-dom";
import { CODE_LABELS, codeToLabel, isCsvOnlyProduct, isManualEntryProduct } from "./constants.js";
import { useUploadStore } from "./uploadStore.js";
import UploadBackButton from "./UploadBackButton.jsx";

const BASE_PATH = "/lender/upload"; // ✅ Portal-safe base path

export default function UploadTabs({ ptype }) {
  const nice = CODE_LABELS?.[ptype];
  const label =
    (typeof codeToLabel === "function" ? codeToLabel(ptype) : null) ||
    nice ||
    "Select Product";

  const { state } = useUploadStore();

  const DocBadge = ({ label, file }) => {
    if (!file) return null;
    const kb = file.size ? Math.max(1, Math.round(file.size / 1024)) : null;
    return (
      <span
        className="inline-flex items-center gap-1 rounded-full bg-sky-50 border border-sky-200 px-2 py-1 text-xs text-sky-900"
        title={file.name}
      >
        {/* paper icon */}
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" className="shrink-0">
          <path d="M7 3h6l5 5v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" stroke="currentColor" strokeWidth="1.5" />
          <path d="M13 3v5h5" stroke="currentColor" strokeWidth="1.5" />
        </svg>
        <span className="font-medium">{label}:</span>
        <span className="truncate max-w-[12rem]">{file.name}</span>
        {kb ? <span className="opacity-60">({kb} KB)</span> : null}
      </span>
    );
  };

  const csvOnly = isCsvOnlyProduct(ptype);
  const manualOnly = isManualEntryProduct(ptype);

  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
      {/* Left: product pill + tabs */}
      <div className="flex flex-wrap items-center gap-3">
        <UploadBackButton />
        <div className="px-3 py-1.5 rounded-lg bg-sky-50 border border-sky-200 text-sky-900 text-sm font-semibold">
          Product: {label || "—"}
        </div>

        {csvOnly ? (
          <span className="px-4 py-2 rounded-xl border border-sky-300 bg-sky-400 text-white text-sm font-semibold">
            CSV Bulk Upload
          </span>
        ) : manualOnly ? (
          <>
            <NavLink
              to={`${BASE_PATH}/${ptype || ""}/manual`}
              className={({ isActive }) =>
                `px-4 py-2 rounded-xl border text-sm font-semibold transition-all ${isActive
                  ? "bg-sky-400 text-white border-sky-600"
                  : "bg-white text-slate-700 hover:border-sky-300 hover:bg-sky-50"
                }`
              }
            >
              Manual Entry
            </NavLink>

            <NavLink
              to={`${BASE_PATH}/${ptype || ""}/csv`}
              className={({ isActive }) =>
                `px-4 py-2 rounded-xl border text-sm font-semibold transition-all ${isActive
                  ? "bg-sky-400 text-white border-sky-600"
                  : "bg-white text-slate-700 hover:border-sky-300 hover:bg-sky-50"
                }`
              }
            >
              CSV Bulk Upload
            </NavLink>
          </>
        ) : null}
      </div>

      {/* Right: badges */}
      <div
        key={state.lastUpdatedAt}
        className="flex flex-wrap items-center gap-2"
      >
        <DocBadge label="Valuation" file={state.valuationDoc} />
        <DocBadge label="Legal" file={state.legalFeesDoc} />
      </div>
    </div>
  );
}

